import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=22424535&scoped=true&lang=html&"
import script from "./Team.vue?vue&type=script&lang=coffee&"
export * from "./Team.vue?vue&type=script&lang=coffee&"
import style0 from "./Team.vue?vue&type=style&index=0&id=22424535&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22424535",
  null
  
)

component.options.__file = "Team.vue"
export default component.exports